import axios from 'axios';
import api from '../services/api' // axios instance
import {ROUTES, API_ENDPOINTS,ImageUploadApi,MenuImageApi} from '@myorg/type-lib'
import {ImageUploader} from '@myorg/r2-lib'
import { logger } from '@myorg/type-lib';


export const imageUploadApiImpl: ImageUploadApi = {
  // 從 Go 後端拿到 R2 的簽名 URL
  // getUploadTicket: async (fileName: string) => {
  //   // 這裡調用你的 Go 後端 API
  //   const res = await api().get(`/api/go-bff-service/r2/get_presigned_url`, { params: { idx: '1' } })
  //   logger.log(res)
  //   return res.data // 回傳 { uploadUrl, publicUrl }
  // },
  getUploadTicket: async (fileName: string, idx: string) => {
    const res = await api().get(API_ENDPOINTS.BFF.R2_PRESIGNED_URL, { 
      params: { 
        fileName, 
        idx // 這裡傳給 Go: ?fileName=xxx&idx=1
      } 
    })
    return res.data
  },

  // 真正執行 PUT 到 Cloudflare R2
  putToR2: async (url: string, blob: Blob) => {
    logger.log(url)
    await axios.put(url, blob, {
      headers: { 'Content-Type': 'image/jpeg' }
    })
  },

  deleteImage: async (idx: string) => {
    // 這裡對應你 Go 後端的路由
    // 通常我們會傳送 idx，而 merchantId 則由後端從 JWT/Session 中取得以確保安全
    await api().delete(API_ENDPOINTS.BFF.R2_PRESIGNED_URL, {
      params: { idx }
    })
  }
}

export const menuImageApiImpl:MenuImageApi = {
  getImages: async () => {
    const res = await api().get(API_ENDPOINTS.BOOKING.IMAGES)
    return res.data
  },
  confirmUpload: async (idx: number) => {
    const res = await api().post(API_ENDPOINTS.BOOKING.IMAGE_COMPLETE(idx))
    return res.data
  }
}